import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Field } from "@/components/shared/Common";
import { api, errMsg } from "@/lib/api";
import { Pick } from "@/pages/gerencia/Sales";

const EMPTY = { sueldo_base: "", jornada_semanal: 42, jornada_diaria: 8.4, colacion_min: 0, contrato: "indefinido", afp: "", salud: "fonasa", isapre_plan_uf: 0, gratificacion: true, colacion: 0, movilizacion: 0 };
const CONTRATOS = [{ id: "indefinido", name: "Indefinido" }, { id: "plazo_fijo", name: "Plazo fijo" }, { id: "obra_faena", name: "Obra o faena" }];
const SALUD = [{ id: "fonasa", name: "Fonasa (7%)" }, { id: "isapre", name: "Isapre" }];
const NUMS = [["sueldo_base", "Sueldo base mensual (CLP) *"], ["jornada_semanal", "Jornada semanal (horas)"], ["jornada_diaria", "Jornada diaria normal (horas)"],
  ["colacion_min", "Colación no imputable (min/día)"], ["colacion", "Asignación colación mensual (no imponible)"], ["movilizacion", "Asignación movilización mensual (no imponible)"]];

export const PayTab = ({ empId, canEdit }) => {
  const [f, setF] = useState(EMPTY);
  const [afps, setAfps] = useState([]);
  useEffect(() => {
    api.get(`/rrhh/payroll/employees/${empId}/pay`).then((r) => setF({ ...EMPTY, ...r.data }));
    api.get("/rrhh/payroll/params").then((r) => setAfps(Object.keys(r.data.afp).map((k) => ({ id: k, name: `${k} (${r.data.afp[k]}%)` }))));
  }, [empId]);
  const set = (k, v) => setF({ ...f, [k]: v });
  const save = async () => {
    const body = { ...f };
    NUMS.forEach(([k]) => { body[k] = Number(body[k]) || 0; });
    body.isapre_plan_uf = Number(body.isapre_plan_uf) || 0;
    try { await api.put(`/rrhh/payroll/employees/${empId}/pay`, body); toast.success("Remuneración guardada"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="syc-card p-6 space-y-5 max-w-3xl" data-testid="pay-tab">
      <p className="text-xs text-[#5b6656]">Base para la pre-nómina. Las horas extra se calculan solas con las marcas de entrada y salida sobre la jornada diaria.</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {NUMS.map(([k, l]) => <Field key={k} label={l}><Input data-testid={`pay-${k}-input`} type="number" min="0" step="any" disabled={!canEdit} value={f[k]} onChange={(e) => set(k, e.target.value)} /></Field>)}
        <Field label="Tipo de contrato"><Pick testid="pay-contrato-select" value={f.contrato} onChange={(v) => set("contrato", v)} options={CONTRATOS} /></Field>
        <Field label="AFP"><Pick testid="pay-afp-select" value={f.afp} onChange={(v) => set("afp", v)} options={afps} placeholder="Seleccione AFP" /></Field>
        <Field label="Salud"><Pick testid="pay-salud-select" value={f.salud} onChange={(v) => set("salud", v)} options={SALUD} /></Field>
        {f.salud === "isapre" && <Field label="Plan Isapre (UF)"><Input data-testid="pay-isapre-input" type="number" min="0" step="any" disabled={!canEdit} value={f.isapre_plan_uf} onChange={(e) => set("isapre_plan_uf", e.target.value)} /></Field>}
        <label className="flex items-center gap-3 text-sm pt-6"><Switch data-testid="pay-gratificacion-switch" disabled={!canEdit} checked={f.gratificacion} onCheckedChange={(v) => set("gratificacion", v)} />Gratificación legal mensual (25%, tope 4,75 IMM)</label>
      </div>
      {canEdit && <Button data-testid="pay-save-btn" className="rounded-full" onClick={save}>Guardar remuneración</Button>}
    </div>
  );
};
